module.exports = __webpack_public_path__ + "img/dasd.7107d0b6.svg";